module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "box-head clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "card-head"
  }, [_vm._v("Facebook Insights")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('el-select', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.facebookPage),
      callback: function($$v) {
        _vm.facebookPage = $$v
      },
      expression: "facebookPage"
    }
  }, _vm._l((_vm.facebookPages), function(page) {
    return _c('el-option', {
      key: page.id,
      attrs: {
        "label": page.handle,
        "value": page.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('el-radio-group', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.period),
      callback: function($$v) {
        _vm.period = $$v
      },
      expression: "period"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "day"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "week"
    }
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "month"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "insights-container"
  }, [_c('loader', {
    attrs: {
      "message": "Loading Insights",
      "shadow": "none"
    }
  })], 1) : (_vm.hasData) ? _c('div', {
    staticClass: "insights-container"
  }, _vm._l((_vm.overviewData), function(value, key) {
    return _c('InsightsOverviewItem', {
      key: key,
      staticClass: "insight-item",
      attrs: {
        "data": value,
        "period": _vm.period
      },
      on: {
        "onNavigate": function($event) {
          return _vm.handleItemNavigate(key)
        }
      }
    })
  }), 1) : _c('div', {
    staticClass: "placeholder"
  }, [_c('content-placeholder', {
    attrs: {
      "count": 1,
      "text-only": true,
      "text-value": _vm.facebookPage ? 'No data' : 'No page connected'
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ca93186","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/social/facebook/InsightsOverview.vue
// module id = 3235
// module chunks = 3